/**
 * マスク付きリビールアニメーション
 *
 * .js-reveal-mask が画面内に入ったタイミングで -viewed を付与し、
 * .c_reveal_mask__in を下から表示する。
 *
 * 調整値:
 * - duration は SCSS の --reveal-mask-duration
 * - step の遅延は SCSS の --reveal-mask-delay
 * - 発火位置やマスク解除タイミングは revealMaskConfig
 * - 個別調整は data-reveal-mask-start / data-reveal-mask-release-delay
 */
document.addEventListener("DOMContentLoaded", function () {
  var targets = document.querySelectorAll(".js-reveal-mask");
  if (!targets.length) return;

  var revealMaskConfig = {
    start: "top 88%",
    releaseDelay: 1000,
    sequenceStep: 140,
  };

  var getNumberValue = function (value, fallback) {
    var parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : fallback;
  };

  var getSequenceDelay = function (target) {
    var sequenceRoot = target.closest("[data-reveal-mask-sequence]");
    if (!sequenceRoot) return 0;

    if (!sequenceRoot._revealMaskSequenceTargets) {
      sequenceRoot._revealMaskSequenceTargets = Array.prototype.slice.call(
        sequenceRoot.querySelectorAll(".js-reveal-mask"),
      );
    }

    var sequenceTargets = sequenceRoot._revealMaskSequenceTargets;
    var targetIndex = sequenceTargets.indexOf(target);
    if (targetIndex < 0) return 0;

    var sequenceStep = getNumberValue(
      sequenceRoot.dataset.revealMaskSequence,
      revealMaskConfig.sequenceStep,
    );

    return sequenceStep * targetIndex;
  };

  var reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (reduceMotion) {
    targets.forEach(function (target) {
      target.classList.add("is-reveal-mask-active", "-mask-released");
    });
    return;
  }

  if (
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    targets.forEach(function (target) {
      target.classList.add("is-reveal-mask-active", "-mask-released");
    });
    return;
  }

  window.gsap.registerPlugin(window.ScrollTrigger);

  targets.forEach(function (target) {
    var releaseDelay = getNumberValue(
      target.dataset.revealMaskReleaseDelay,
      revealMaskConfig.releaseDelay,
    );
    var sequenceDelay = getSequenceDelay(target);

    window.ScrollTrigger.create({
      trigger: target,
      start: target.dataset.revealMaskStart || revealMaskConfig.start,
      once: true,
      onEnter: function () {
        window.setTimeout(function () {
          target.classList.add("-viewed");
          window.setTimeout(function () {
            target.classList.add("-mask-released");
          }, releaseDelay);
        }, sequenceDelay);
      },
    });
  });
});
